module.exports = __webpack_public_path__ + "static/img/23_zongliuliang.7d3a8150.png";